import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import "./styles/globals.css";

import { queryClient } from "./lib/query";
import { router } from "./router";

function setMeta(attr: "name" | "property", key: string, content: string): void {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

const title = "Chill \u2014 A website you update by text";
const description =
  "Tell Chill what you need. It builds the site and keeps it current. No editor to learn. From $25/month after 14 days free.";

document.title = title;
setMeta("name", "description", description);
setMeta("property", "og:title", title);
setMeta("property", "og:description", description);
setMeta("name", "twitter:title", title);
setMeta("name", "twitter:description", description);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
